import { alpha, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  errorLabelStyle: {
    fontFamily: 'Roboto',
    color: '#D32F2F',
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginTop: '10px',
    minHeight: '20px',
  },
  selectModeStyle: {
    color: '#fdfdfe',
    fontSize: '16px',
    lineHeight: '1',
    fontWeight: 'normal',
    width: '100%',
    wordWrap: 'break-word',
    minWidth: 0,
    padding: '10px 16px',
  },
  newRowContainer: {
    display: 'flex',
    height: '27px',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: '8px',
    '&:hover': {
      cursor: 'pointer',
    },
    marginBottom: 40,
  },
  addIcon: {
    color: '#B1A3B1',
    height: '24px',
    width: '24px',
  },
  addText: {
    fontSize: '16px',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
  },
  actionsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
  },
  actionsLabel: {
    padding: '8px',
  },
  cancelButton: {
    width: '110px',
    height: '40px',
    minHeight: '40px',
    borderRadius: '6px',
    border: '1px solid #8B808E',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#ffffff',
  },
  redBtn: {
    width: '110px',
    height: '40px',
    minHeight: '40px',
    borderRadius: '6px',
    boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.1)',
    textTransform: 'none',
    backgroundColor: theme.palette.secondary.main,
    border: 0,
    '&:hover': {
      backgroundColor: alpha(theme.palette.secondary.main, 0.7),
      border: 0,
    },
    '&:focus': {
      backgroundColor: '#b3b3b3',
      border: 0,
    },
    '&:active': {
      backgroundColor: theme.palette.secondary.main,
      border: 0,
    },
    '&:disabled': {
      color: '#fdfdfe !important',
      opacity: 0.4,
      backgroundColor: `${theme.palette.secondary.main} !important`,
    },
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#ffffff',
  },
}));
